import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import React from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormInputLabel } from './FormInputLabel';

export const FormRadio = React.forwardRef((props, ref) => {
  const { label, error, menus, control, radioGroupSx, ...rest } = props;
  const { t } = useTranslation();
  return (
    <div className='flex flex-col gap-1'>
      {label && <FormInputLabel label={label} isRequired={rest.required} />}
      <Controller
        control={control}
        name={rest.name}
        render={({ field }) => {
          return (
            <RadioGroup
              row
              sx={radioGroupSx}
              value={field.value}
              onChange={(e) => {
                field.onChange(e.target.value);
              }}
            >
              {menus.map((el) => (
                <FormControlLabel key={el.value} value={el.value} control={<Radio />} label={t(el.label)} />
              ))}
            </RadioGroup>
          );
        }}
      />
      {error && <FormHelperText error>{error.message}</FormHelperText>}
    </div>
  );
});

FormRadio.displayName = 'FormRadio';
